var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-page-note"},[_c('div',{staticClass:"m-block"},[_c('div',{staticClass:"m-note-title"},[_c('en',{attrs:{"s":"Cancel<br>Domain for<br>Hashimoto Salonあ"}})],1)]),_vm._v(" "),_c('div',{staticClass:"m-device-background"})])}
var staticRenderFns = []

export { render, staticRenderFns }